import { UseQueryResult, useQuery } from "@tanstack/react-query";

//App
import {
  LookupGroupApiResponse,
  LookupGroupContextData,
  LookupGroupProps,
  LookupGroupState,
} from "../../../../../types/lookupGroup";
import { LookupGroupContext } from "../LookupGroupContainer";
import useForm from "../../../../hooks/useForm";
import { queryKeys } from "../constants";
import {
  EMPTY_GUID,
} from "../../../../../utility/constants";
import lookupGroupApi from "../../../../../app/model/api/lookupGroupApi";
import { FormikTypeaheadOption } from "../../../../../types";

const useLookupGroup = (props: LookupGroupProps) => {
  return useForm<LookupGroupContextData, LookupGroupProps>(
    LookupGroupContext,
    props
  );
};

export const useLookupGroupGridQuery = (state: LookupGroupState) =>
  useQuery({
    queryKey: [queryKeys.getLookupGroups, state.lookupTypeId],
    queryFn: () =>
      lookupGroupApi.searchLookupGroups({
        ...state.searchPayload,
        lookupTypeId: state.lookupTypeId,
        pageSize: state.pageSize,
        pageNumber: state.currentPage,
        isActive: state.activeToggle,
        sortBy: state.sortBy,
      }),
  });

export const useLookupGroupQuery = (lookupGroupId: string | null) =>
  useQuery({
    queryKey: [queryKeys.getLookupGroup, lookupGroupId],
    queryFn: () => lookupGroupApi.get(lookupGroupId ?? EMPTY_GUID),
    enabled: lookupGroupId !== null,
  });

export const useLookupGroupsQuery = (lookupTypeId: string | null) =>
  useQuery({
    queryKey: [queryKeys.getLookupGroups, lookupTypeId],
    queryFn: () =>
      lookupGroupApi.getAllByLookupTypeId({
        lookupTypeId: lookupTypeId,
        isActive: true,
      }),
    select: (data) =>
      data?.result?.map((lookupGroup) => ({
        label: lookupGroup.name as string,
        value: lookupGroup.id as string,
      })) as FormikTypeaheadOption[],
    enabled: lookupTypeId != null,
  });

export const useLookupGroupsData = (
  lookupGroupGridQuery: UseQueryResult<LookupGroupApiResponse, Error>
) => lookupGroupGridQuery?.data as LookupGroupApiResponse;

export default useLookupGroup;
